// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"46":"a72b00e528eb245c","618":"5f2b07e22a8bc7ce","648":"988c34e534f6d503","814":"dc1bcbd2ddc1ef22","860":"052fb62bb686ecec"}[chunkId] + ".js";
};